import React from 'react'
import './Enterprise.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import Seo from '../seo/Seo';
import Breadcrumbs from './Breadcrumbs';
import LocalImage from './LocalImage';

const Enterprise = () => {
  return (
    <div>
         <Seo
           title="Contact Management for Teams & Enterprise Digital Cards | Connct"
           description="Branded NFC digital business cards for your whole team, with central admin, lead capture, CRM export and networking analytics. Get a demo for your company."
           path="/enterprise"
           breadcrumbs={[
             { name: "Home", path: "/" },
             { name: "Enterprise", path: "/enterprise" },
           ]}
         />
         <div className="wrapper" style={{marginTop:'150px'}}>
      <section className="enterprise section" >
        <div className="container">
          <div className="page-header">
            <Breadcrumbs
              items={[
                { name: "Home", path: "/" },
                { name: "Enterprise", path: "/enterprise" },
              ]}
            />
            <h1 className="h2" style={{fontWeight:'800'}}>Digital business cards and contact management for teams</h1>
            <p style={{fontSize:'18px'}}>Track your team's networking performance.</p>
            <p style={{fontSize:'18px'}}>Equip your team with the next-gen NFC cards and track all their networking performance in one go.</p>
          </div><br/>
          <hr className="lightgray-line" /> <br/>
          <div className="row">
            <div className="col-12">
              <p style={{fontSize:'18px'}}>Drop us an email to equip your team with Conncts' customized one-tap digital business cards in your brand's
                style & improve your team’s networking ROI.</p><br/><br/>
            </div>
            
            <div className="row section" style={{marginTop:'15px'}}>
            <div className="col-md-6">
    <div className="mb-4 d-flex align-items-center">
        <FontAwesomeIcon icon={faCheckCircle} style={{ color: '#FAAD3D', marginRight: '10px', marginTop: '-17px' }} /> {/* Adjusted margin-bottom */}
        <div>
            <p style={{ fontSize: '18px', fontWeight: '600', margin: '0', padding: '0' }}>Download all your leads</p>
            <p style={{ margin: '0', color: 'black', fontSize: '16px' }}>Download all your contacts directly from your connection list.</p>
        </div>
    </div>
    <div className="mb-4 d-flex align-items-center">
        <FontAwesomeIcon icon={faCheckCircle} style={{ color: '#FAAD3D', marginRight: '10px', marginTop: '-17px' }} /> {/* Adjusted margin-bottom */}
        <div>
            <p style={{ fontSize: '18px', fontWeight: '600', margin: '0', padding: '0' }}>Eliminate paper wastage</p>
            <p style={{ margin: '0', color: 'black', fontSize: '16px' }}>Every time one team member switches to connect, you take one step towards saving Trees.</p>
        </div>
    </div>
    <div className="mb-4 d-flex align-items-center">
        <FontAwesomeIcon icon={faCheckCircle} style={{ color: '#FAAD3D', marginRight: '10px', marginTop: '-17px' }} /> {/* Adjusted margin-bottom */}
        <div>
            <p style={{ fontSize: '18px', fontWeight: '600', margin: '0', padding: '0' }}>Track networking efforts</p>
            <p style={{ margin: '0', color: 'black', fontSize: '16px' }}>Track your whole team’s networking performance, calculating overall ROI.</p>
        </div>
    </div>
    <br />
    <h5 className="mb-4" style={{ fontSize: '20px', fontWeight: '600' }}>Set your team with the most-advanced digital visiting card and see the networking ROI jump
        in no time.</h5>
    <br />
    <a href="/contact" className="df" type="button">Get Started</a>
</div>


              <div className="col-md-6">
                <LocalImage
                 className="img-fluid mx-auto d-block image-md"
                 src={require('../assets/images/improve-networking-ROI.png')}
                 webp={require('../assets/images/improve-networking-ROI.webp')}
                 alt="Set your team with the most-advanced digital visiting card"
                 width={900}
                 height={900}
                 style={{width:'500px', maxWidth:'100%', aspectRatio:'1 / 1'}}
                 />
              </div>
            </div>
                      
            <section className="info-text" style={{marginTop:'40px'}}>
              <div className="container">
                <div className="col-sm-8 mx-auto">
                  <h3 className="fw-bold">Real-time <span style={{color:'rgba(4, 69, 157, 1)'}}>Advanced Analytics</span>. Brand-styled <span
                    style={{color:'#FAAD3D'}}>visiting card</span> design. Standardized <span  style={{color:'#FAAD3D'}}>employee
                    profiles</span></h3>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section><br/><br/><br/>
    </div>
    </div>
  )
}

export default Enterprise